export const AuthServiceDataToken = "Auth.authData";
export const AuthServiceIdToken = "Auth.authIdToken";
export const AuthServiceLogoutToken = "Auth.authLogout";
export const AuthServiceNoAccessToken = "Auth.authNoAccessLogout";

export const AppTheme = "App.theme";
export const AppIdleForcedLogoutToken = "App.idleForcedLogout";
export const AppRootOrgFilterToken = "App.rootOrgFilter";

export const ListViewPageSizeToken = "ListView.pageSize";
export const ManageViewPageSizeToken = "ManageView.pageSize";
export const OrgsTreeViewEnabledToken = "OrgsListView.treeViewEnabled";
export const OrgsTreeExpandedToken = "OrgsListView.treeViewExpandedState";

export const AccordionUserOrgsToken = "Accordion.userOrgs";
